var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForSignUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "48.339%",
    x2: "53.95%",
    y1: "64.844%",
    y2: "39.522%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00008B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "51.022%",
    x2: "48.848%",
    y1: "-1.843%",
    y2: "108.301%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#88CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".834%",
    stopColor: "#89CFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.84%",
    stopColor: "#C8D9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.18%",
    stopColor: "#F0DFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "51.232%",
    x2: "48.993%",
    y1: "50.968%",
    y2: "48.804%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00008B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "101.704%",
    x2: "3.106%",
    y1: "28.026%",
    y2: "69.93%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13.45%",
    stopColor: "#7E85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.66%",
    stopColor: "#8B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44.72%",
    stopColor: "#A2A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.37%",
    stopColor: "#C2C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.32%",
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.1%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    x2: "100.001%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15.85%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.35%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.76%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.37%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "49.995%",
    x2: "49.995%",
    y1: "-2.419%",
    y2: "101.42%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "19.27%",
    stopColor: "#E19000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "36%",
    stopColor: "#E39504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.57%",
    stopColor: "#E9A410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.05%",
    stopColor: "#F3BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "47.975%",
    x2: "52.207%",
    y1: "-59.01%",
    y2: "76.378%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13.45%",
    stopColor: "#7E85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.66%",
    stopColor: "#8B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44.72%",
    stopColor: "#A2A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.37%",
    stopColor: "#C2C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.32%",
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.1%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: ".004%",
    x2: "100%",
    y1: "49.995%",
    y2: "49.995%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#88CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".834%",
    stopColor: "#89CFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.84%",
    stopColor: "#C8D9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.18%",
    stopColor: "#F0DFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "49.095%",
    x2: "52.143%",
    y1: "18.605%",
    y2: "125.08%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "53.684%",
    x2: "47.444%",
    y1: "-18.334%",
    y2: "118.722%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13.45%",
    stopColor: "#7E85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.66%",
    stopColor: "#8B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44.72%",
    stopColor: "#A2A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.37%",
    stopColor: "#C2C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.32%",
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.1%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "-.004%",
    x2: "99.998%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#88CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".834%",
    stopColor: "#89CFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.84%",
    stopColor: "#C8D9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.18%",
    stopColor: "#F0DFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "49.999%",
    x2: "49.999%",
    y1: "-1.25%",
    y2: "103.163%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15.85%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.35%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.76%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.37%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "54.8%",
    x2: "46.362%",
    y1: "-9.884%",
    y2: "115.152%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13.45%",
    stopColor: "#7E85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.66%",
    stopColor: "#8B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44.72%",
    stopColor: "#A2A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.37%",
    stopColor: "#C2C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.32%",
    stopColor: "#EAEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.1%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "-.002%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#88CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".834%",
    stopColor: "#89CFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.84%",
    stopColor: "#C8D9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.18%",
    stopColor: "#F0DFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "-.031%",
    x2: "100.002%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.14%",
    stopColor: "#10003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#090E96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "-.015%",
    x2: "100.018%",
    y1: "50.013%",
    y2: "50.013%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "-.245%",
    x2: "99.618%",
    y1: "50.552%",
    y2: "50.552%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.47%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: ".03%",
    x2: "100.045%",
    y1: "50.017%",
    y2: "50.017%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15.85%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.35%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.76%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.37%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "48.777%",
    x2: "51.78%",
    y1: "15.323%",
    y2: "126.783%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.47%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: ".538%",
    x2: "100.491%",
    y1: "50.061%",
    y2: "50.061%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.47%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: "-.227%",
    x2: "100.299%",
    y1: "50.093%",
    y2: "50.093%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.47%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: "-.04%",
    x2: "99.864%",
    y1: "49.936%",
    y2: "49.936%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7981FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.47%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "30.398%",
    x2: "62.058%",
    y1: "4.334%",
    y2: "99.75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: "49.995%",
    x2: "49.995%",
    y1: "-.094%",
    y2: "110.33%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.14%",
    stopColor: "#10003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#090E96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: "-.041%",
    x2: "99.998%",
    y1: "49.972%",
    y2: "49.972%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.67%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21.57%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.64%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48.44%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.03%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: "49.999%",
    x2: "49.999%",
    y1: "-.155%",
    y2: "98.863%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.17%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: ".057%",
    x2: "100.048%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "-.199%",
    x2: "99.855%",
    y1: "50.15%",
    y2: "50.15%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: ".336%",
    x2: "100.126%",
    y1: "50.041%",
    y2: "50.041%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: ".007%",
    x2: "100.016%",
    y1: "50.047%",
    y2: "50.047%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: "-.05%",
    x2: "99.993%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#562300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#663B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: "-.023%",
    x2: "100.132%",
    y1: "49.966%",
    y2: "49.966%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.67%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21.57%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.64%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48.44%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.03%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: ".108%",
    x2: "99.98%",
    y1: "50.049%",
    y2: "50.049%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.67%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21.57%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.64%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48.44%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.03%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: "49.978%",
    x2: "49.978%",
    y1: "13.317%",
    y2: "91.403%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15.85%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.35%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.76%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.37%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: "-.017%",
    x2: "100%",
    y1: "50.041%",
    y2: "50.041%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "19.27%",
    stopColor: "#E19000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "36%",
    stopColor: "#E39504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.57%",
    stopColor: "#E9A410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.05%",
    stopColor: "#F3BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: "50.459%",
    x2: "48.848%",
    y1: "20.227%",
    y2: "110.461%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: "49.991%",
    x2: "49.991%",
    y1: "12.052%",
    y2: "103.136%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: ".001%",
    x2: "100%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: "-.021%",
    x2: "100.001%",
    y1: "49.957%",
    y2: "49.957%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: "0%",
    x2: "99.995%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#311341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.99%",
    stopColor: "#3113C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.79%",
    stopColor: "#2F18C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.31%",
    stopColor: "#2927CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65.24%",
    stopColor: "#1F40D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.19%",
    stopColor: "#1263E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.78%",
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: "46.614%",
    x2: "65.735%",
    y1: "36.994%",
    y2: "106.588%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.32%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: "50.067%",
    x2: "51.151%",
    y1: "10.976%",
    y2: "93.444%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.14%",
    stopColor: "#100022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#090E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: "41.445%",
    x2: "96.409%",
    y1: "29.793%",
    y2: "75.744%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.14%",
    stopColor: "#10003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.46%",
    stopColor: "#10013E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45.94%",
    stopColor: "#0F0249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.35%",
    stopColor: "#0E055B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.11%",
    stopColor: "#0C0974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.26%",
    stopColor: "#090E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#090E96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: ".007%",
    x2: "99.999%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15.85%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.35%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56.76%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.37%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: "3.2%",
    x2: "97.527%",
    y1: "44.242%",
    y2: "65.286%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7633FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9.67%",
    stopColor: "#7137FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21.57%",
    stopColor: "#6243FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.64%",
    stopColor: "#4957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48.44%",
    stopColor: "#2672FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.03%",
    stopColor: "#0090FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M15.23 376.9H731.8s24.82-159.12-85.31-257.35C536.37 21.31 376.61 97.41 376.61 97.41S291.92-31.93 156.36 7.47C-65.65 72.01 15.23 376.9 15.23 376.9Z",
    transform: "translate(33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M243.39 97.95h92.97c5.05-2.61 8.51-7.9 8.51-14 0-7.9-5.8-14.44-13.35-15.56.01-.26.02-.51.02-.77 0-9.24-7.64-16.73-17.06-16.73-.99 0-1.95.08-2.89.24-4.06-7.05-11.99-11.84-21.11-11.84-10.62 0-19.63 6.5-22.79 15.5-1-.2-2.02-.31-3.07-.31-9.06 0-16.4 7.79-16.4 17.4 0 1.08.09 2.14.27 3.16-6.86.44-12.27 5.69-12.27 12.1-.01 4.71 2.91 8.79 7.17 10.81Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(138 31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M95.54 10.25c0 .46-.34.82-.76.82s-.76-.37-.76-.82c0-.46.34-.82.76-.82s.76.36.76.82ZM59.51 73.84c0 .46-.34.82-.76.82s-.76-.37-.76-.82c0-.46.34-.82.76-.82.42-.01.76.36.76.82ZM2.2 63.87c0 .46-.34.82-.76.82s-.76-.37-.76-.82c0-.46.34-.82.76-.82.43 0 .76.37.76.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.74,
    cy: 33.33,
    r: 32.5,
    fill: "url(#b)",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M38.23 1.9S-9.45 13.6 2.28 59.32C8.41 83.21 53.24 88.73 116.1 88.73c1.47 0 2.94-.01 4.4-.02 1.34.45 2.7.89 4.08 1.3 73.88 21.87 174.74.04 265.96-27.41 71.42-21.49 233.11-17.63 283.58-17.63 174.54 0 80.69-43.06 80.69-43.06H38.23V1.9Z",
    transform: "translate(10 375)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000640",
    fillRule: "nonzero",
    d: "M741.69 407.8H308.71v-31.82h401.16z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000640",
    d: "M335.71 434.8c0 9.59-70.45 17.36-157.35 17.36-86.9 0-157.35-7.77-157.35-17.36s70.45-17.36 157.35-17.36c86.9 0 157.35 7.78 157.35 17.36Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83FFFF",
    fillRule: "nonzero",
    d: "m82.09 127.18 232.4-17.36-4.82 258.44L67.63 187.93",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    d: "M411.71 248.28c0 5.5-4.46 9.97-9.97 9.97H10.91c-5.5 0-9.97-4.46-9.97-9.97V10.04C.94 4.54 5.4.07 10.91.07h390.84c5.5 0 9.97 4.46 9.97 9.97v238.24h-.01Z",
    transform: "translate(306 110)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M.94 12.79h410.77v31.57H.94z",
    transform: "translate(306 110)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M665.01 138.85a7.65 7.65 0 0 1-7.65 7.65H383.99c-4.22 0-7.65-3.43-7.65-7.65 0-4.23 3.42-7.65 7.65-7.65h273.37c4.22 0 7.65 3.43 7.65 7.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M.03 23.07h109.22v134.98H.03z",
    transform: "translate(448 242)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M52.28 80.04h-.1l-5.98 2.84-1.21-5.5 8.29-3.86h6.08v31.34h-7.09V80.04z",
    transform: "translate(448 242)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M109.9 23.21H0L9.19.56h91.82z",
    opacity: 0.8,
    transform: "translate(448 242)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M.9 23.57h100.99v73.49H.9z",
    transform: "translate(320 303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M40.43 70.77c1.3.67 4.29 1.93 7.28 1.93 3.81 0 5.74-1.83 5.74-4.19 0-3.09-3.09-4.48-6.32-4.48h-2.99v-5.26h2.84c2.46-.05 5.59-.96 5.59-3.62 0-1.88-1.54-3.28-4.63-3.28-2.56 0-5.26 1.11-6.56 1.88l-1.49-5.3c1.88-1.21 5.64-2.36 9.69-2.36 6.7 0 10.41 3.52 10.41 7.81 0 3.33-1.88 5.93-5.74 7.28v.1c3.76.67 6.8 3.52 6.8 7.62 0 5.55-4.87 9.6-12.83 9.6-4.05 0-7.47-1.06-9.31-2.22l1.52-5.51Z",
    transform: "translate(320 303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M101.88 23.57H.9L13.04.93h95.64z",
    opacity: 0.8,
    transform: "translate(320 303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M428.68 303.93v77s-6.8 22.84-6.8 19.13v-73.49l6.8-22.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M12.31 23.07H113.3v100.99H12.31z",
    transform: "translate(570 276)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M50.8 90.16v-4.44l4.05-3.66c6.85-6.12 10.17-9.64 10.27-13.31 0-2.56-1.54-4.58-5.16-4.58-2.7 0-5.06 1.35-6.7 2.6l-2.07-5.26c2.36-1.78 6.03-3.23 10.27-3.23 7.09 0 10.99 4.15 10.99 9.84 0 5.26-3.81 9.45-8.34 13.5l-2.89 2.41v.1h11.81v6.03H50.8Z",
    transform: "translate(570 276)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M113.21 23.07H12.4L.47.43h104.87z",
    opacity: 0.8,
    transform: "translate(570 276)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M570.47 276.43V381.6s11.84 21.5 11.84 18.46V297.09l-11.84-20.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000640",
    fillRule: "nonzero",
    d: "M397.8 316.45c0 3.43-10.84 6.22-24.22 6.22-13.37 0-24.22-2.78-24.22-6.22 0-3.43 10.84-6.21 24.22-6.21 13.37 0 24.22 2.78 24.22 6.21Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.2,
    cy: 256.66,
    fill: "#000640",
    fillRule: "nonzero",
    opacity: 0.2,
    rx: 32.47,
    ry: 5.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000640",
    fillRule: "nonzero",
    d: "M655.18 289.19c0 3.73-11.35 6.75-25.35 6.75-14 0-25.35-3.02-25.35-6.75s11.35-6.75 25.35-6.75c14 0 25.35 3.02 25.35 6.75Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEA886",
    d: "M413.8 191.88s-2.15 2.21-2.23 2.45c-.08.23-1.34-3.66-1.34-3.66l3.57 1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M410.23 190.67s-.74-2.4-.84-2.77c-.1-.37.24-1.38.73-2.51s1.67-2.43 1.87-2.47c.21-.04.4-.17.9.06.49.23.79.7.79.7s.74 0 1.06.6c0 0 .7.03.95.77 0 0 .68.05.82.6 0 0-.34 1.02-.36 1.43-.02.41-1.23 2.95-2.35 4.81 0-.01-1.3.91-3.57-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M411.87 183.21s-1.18 2.89-.74 3.14c.44.25.76.07.76.07l.05 1.41s.56.92 1.39.04c0 0 .44.91 1.14-.04 0 0 .56.47.96.09.4-.38 1.08-2.27 1.08-2.27s-.03-.47-.82-.6c0 0-.19-.72-.95-.77 0 0-.25-.56-1.06-.6 0 0-.65-1.2-1.68-.75.01-.01-.08.16-.13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M409.42 187.81s1.63-1.4 2.85-1.77c.28-.09.56-.12.74.11.18.22.09.77-.59 1.42-.67.64-1.25 1.78-1.25 1.78s-.88.45-1.75-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M359.92 310.16s-1.43 1.02-2.22 1.74c-.79.71-1.87 1.49-2.53 3.32-.67 1.85.39 3.17 2.17 3.28 1.79.11 4.53-1.24 4.79-2.88.26-1.62 2.37-1.43 2.64-2.58.27-1.15-.09-2.57-.09-2.57l-4.76-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEA886",
    d: "m360.16 308.82-.24 1.34s.74 1.36 4.76.3l-.21-1.32-4.31-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6C7B2",
    d: "M364.69 310.46s-.91.12-1.55.22c-.65.1-1.92-.72-3.21-.52l.4 1.63c-.01 0 4.27-.8 4.36-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M385.61 310.16s1.43 1.02 2.22 1.74c.79.71 1.87 1.49 2.53 3.32.67 1.85-.38 3.17-2.17 3.28-1.79.11-4.53-1.24-4.8-2.88-.26-1.62-2.36-1.43-2.64-2.58-.27-1.15.09-2.57.09-2.57l4.77-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEA886",
    d: "m385.37 308.82.24 1.34s-.74 1.36-4.76.3l.21-1.32 4.31-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M35.05 59.93s-13.87-2.73-21.06-.15c-.3.11-.59.23-.86.35 0 0-.02.12-.05.35-.07.53-.22 1.64-.42 3.15-.03.25-.07.52-.11.79C11.53 72.17 10 83.43 9.7 88.93c-.38 7.21-.78 8.24-.78 9.59 0 3.65-1.28 34.43-1.28 34.43s2.18 1.17 5.53 0c0 0 3.96-30.53 4.65-32.79.69-2.26 5.56-22.85 6.42-22.94.86-.1 3.25 21.76 3.43 24.73.18 2.97.01 30.53.99 31.02.98.49 4.97.54 5.26-.44 0 0 1.17-28.02 1.17-30.96 0-2.95.95-25.9.87-26.88-.01 0 .26-7.21-.91-14.76Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M28.58 20.32s6.03 1.77 9.34 2.62c2.68.69 7.35 3.1 12.6 3.93 1.3.2 6.69-12.61 6.69-12.61s5.39 1.27 5.42 1.43c.07.45-7.03 17.51-9.12 18.34-1.64.66-16.01-1.25-16.01-1.25s-1.56 21.82-1.56 24.5c0 2.68.04 9.53.04 9.53s-3.81 2.29-12.59 2.53c0 0-12.96.05-11.65-4.6.97-3.43 1.03-26.71.77-26.84-.26-.13-4.96 5.76-4.51 6.89.46 1.13 12.63 5.2 12.63 5.2s.36 1.31-1.53 4.28c0 0-18.18-5.31-18.24-6.43-.07-1.11 7.56-22.73 10.05-23.86 3.59-1.63 12.96-4.19 12.96-4.19l4.71.53Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6C7B2",
    d: "M380.85 310.46s.91.12 1.55.22c.65.1 1.92-.72 3.21-.52l-.39 1.63c-.01 0-4.28-.8-4.37-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M24.41 49.4s1.31-.04 1.72-.1c.4-.06.14.8-.33.96-.47.17-1.39-.86-1.39-.86Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M19.96 20.93s-.13 5.24 5.26 5.11c5.59-.13 4.42-5.41 4.42-5.41s-4.24-1.91-9.68.3Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M28.39 16.23s-.48 2.66.35 4.48c0 0 .85 4.23-3.48 4.42-4.33.19-4.29-4.57-4.29-4.57s.89-.52.2-4.31c-.69-3.79 7.22-.02 7.22-.02Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M377.76 176.84s5.55.89 4.7 9.78c-.84 8.88-5.74 8.16-6.07 8.15-.33-.01-4.91.16-5.27-10.69 0 .01-.15-8.02 6.64-7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M30.54 8.11s.61-.66.83.01c.22.67-.79 3.57-.87 3.81 0 0-.11.26-.26.12-.13-.14.3-3.94.3-3.94Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M19.26 8s-.59-.68-.83-.01.75 3.72.79 3.83c0 0 .11.26.25.12.15-.14-.21-3.94-.21-3.94Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m382.54 185.48-.79 1.09s.02-2.38-.1-2.76c-.13-.37.15-1.68.04-1.94-.11-.27-3.79.73-9.84.12 0 0 .67 2.15.28 2.3-.39.15-.2 2.79-.2 2.79l-.65-.75s-.74-4.51-.67-5.26c.1-1-.24-5.68 8.26-4.87.97.09 1.91.45 2.69 1.06.88.68 1.77 1.75 1.69 3.21-.11 1.91-.71 5.01-.71 5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M25.17 55.68s-.57.14-.85.08c0 0-.5-.15-.86-.24-.12-.03-.22-.05-.28-.05-.28-.03-.9-.01-1.55-.26s-2.86-1.38-2.86-1.38l.63-2.05.48-1.63s3.73-.99 4.36-.83l.18.06c.52.19.83.56 1.09.69.1.05 1.02.6 1.07.92.07.44-.06.77-.29.98 0 0 .09.87-.23 1.36 0 0 .11.8-.46 1.3-.01 0 .01.82-.43 1.05Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M20.63 49.88s.03 2.75-1.66 4.8c0 0-13.22-4.56-14.81-5.18-1.59-.63 5.78-20.2 5.78-20.2l5.42 1.85-2.91 5.51s-1.44 3.08-4.44 8.16c-.01-.02 1.84 1.61 12.62 5.06Z",
    transform: "translate(352 176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E55353",
    d: "M367.5 198.31s.91-.47 1.76-.56c0 0-.84.39-1.76.56ZM385.26 197.67s1 .14 1.75.49c0 0-1.22-.18-1.75-.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M485.09 250.63s-.89 2-1.64 2.8c-.75.79-3.63 2.21-3.64 4.57-.02 2.56 4.85 1.85 6.75 1.75 1.9-.09 2.05-1.46 2.85-2.91.8-1.45 1.61-1.2 1.76-2.37.15-1.17-.61-3.78-.61-3.78l-5.47-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C568A",
    d: "m485.01 249.89-.14 1.21s2.99 1 5.82.1l-.16-1.66-5.52.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M520.18 250.63s.89 2 1.64 2.8c.75.79 3.63 2.21 3.64 4.57.02 2.56-4.85 1.85-6.75 1.75-1.9-.09-2.05-1.46-2.85-2.91-.8-1.45-1.61-1.2-1.76-2.37-.15-1.17.61-3.78.61-3.78l5.47-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C568A",
    d: "m520.26 249.89.14 1.21s-2.99 1-5.82.1l.16-1.66 5.52.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M39.69 121.63c0 3.15 2.94 31.92 2.94 31.92-.34 1.05-7.56.92-8.69.4s-4.4-29.04-4.61-32.22c-.21-3.18-4.91-30.81-5.9-30.71-.99.1-5.67 29.72-6.46 32.14-.79 2.42-4.36 31.06-4.36 31.06-2.48 1.37-8.37-.34-8.37-.34s1.23-29.41 1.37-30.3c.21-1.31-.01-4.86.56-12.72.51-7.03 2.37-22.34 3.54-30.63.04-.29.08-.58.12-.85.23-1.61.4-2.8.49-3.37l.06-.38c.32-.14.65-.26.99-.38 8.25-2.76 23.96-2.59 23.96-2.59l.23 2.96c.02.17.05.43.1.77.09.73.23 1.82.38 3.08v.03c.01.04.01.08.02.12.55 4.5 1.34 11.08 1.26 11.76-.1 1.06 2.37 27.09 2.37 30.25Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m40.86 28.42-4.05 14.54c-.14.47-.3 1.05-.48 1.73l-.01.03c0 .01 0 .01-.01.02-.68 2.59-1.51 6.54-1.76 10.93-.17 2.99.39 15.03.39 15.03s-6.13 2.29-15.31 1.71c0 0-9.87-.23-9.07-6.28 2.13-16.02.05-22.63-.23-24.24 0 0-1.17-7.38-2.12-13.9 2.78-1.03 14.47-5.42 14.47-5.42l6.15.46c-.01-.02 9.33 2.28 12.03 5.39Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M28.53 22.91c-.35-.88-.15-4.68-.15-4.68s-7.63-2.03-7.43-.54c.18 1.3-.3 4.68-.42 5.52-.21.09-.43.17-.64.28 0 0 1.61 2.8 4.66 3.06 1.94.17 3.6-2.29 4.38-3.5 0 .01-.14-.05-.4-.14Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M25.75 1.99s6 1.01 4.98 10.41c-1.02 9.4-6.32 8.57-6.67 8.55-.35-.01-5.33.11-5.59-11.37.01 0-.07-8.49 7.28-7.59Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M30.86 9.74s.67-.7.9.02c.23.72-1.06 3.88-.98 4.02 0 0-.12.27-.28.12-.16-.15.36-4.16.36-4.16Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M18.54 9.49s-.64-.72-.9-.02.7 3.87.82 4.06c0 0 .21.32.37.18.16-.15-.29-4.22-.29-4.22Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2833",
    d: "m503.55 121.5 1.39 2.12s-1.46.83-2.82-.05l1.43-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M489.22 169.49s7.53 2.78 24.56.16l-.23-3.08s-9.87 2.91-24.03.42l-.3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M507.95 119.04s-1.76 13.17-1.52 24.52c.24 11.34 3.92 32.62 3.92 32.62s6.57-.64 8.2-2.69c0 0-3.77-20.48-3.66-23.51.11-3.03 4.83-25.85 4.83-25.85s-1.85-2.47-11.77-5.09ZM498.52 119.73s-.02 12.48-.26 23.83c-.24 11.34-1.74 32.46-1.74 32.46s-7.7-1.1-9.33-3.15c0 0 2.71-19.87 2.61-22.9-.11-3.03-3.48-25.63-3.48-25.63s1.17-1.66 12.2-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E5E78",
    d: "M499.49 167.52h4.63v3.44h-4.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M502.89 123.09s-2.07 7.05-2.25 21.06c-.18 14.01.25 18.02.25 18.02l1.61 3.19 2.15-3.33s-.69-32.23-.29-38.7l-1.47-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M32.52 46.8s3.06-1.54 3.48-1.81c.42-.27 5.53-1.03 6.18-1.01.64.02.67.53.49.72-.18.18-5.29 1.02-5.38 1.14-.09.12.43.08.43.08s5.5-.08 5.89.28c.39.37-.06.72-.28.81 0 0 .5.58-.08.81-.58.24-1.36.39-1.36.39s.73.37.25.71c-.48.33-6.31 2.14-6.31 2.14s-2.16-4.14-3.31-4.26Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M522.03 153.34c-3.97.95-13.16-.59-16.66-1.36-.74-.16-1.58-.33-2.44-.5-1.43-.28-2.93-.55-4.14-.77a228.8 228.8 0 0 0-2.56-.45s19.28-4.33 19.99-4.33c.71 0-1.78-11.27-1.78-11.27s-2.48-9.44-1.19-13.15c0 0 4.89 1.48 6.48 2.61.88.63 1.53 4.73 2.13 7.51.76 3.53 2.54 11.56 2.74 13.26.17 1.54 1.41 7.5-2.57 8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M492.53 121.55s-5.92 2.02-6.21 2.79c-1.2 3.25-1.76 6.81-2.14 8.23-.47 1.74-1.54 6.95-1.82 8.65-.35 2.17-1.03 9.84-.73 11.02.37 1.49 3.89 1.39 5.79 1.09 1.9-.3 28.28-6.72 28.28-6.72s-1.5-4.91-1.58-5.34c0 0-20.34 2.32-22.93 2.88-1.48.32-1.8.44-1.8.44s4.49-18.4 3.14-23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M17.03 47.52s-2.65-2.16-3.01-2.52c-.36-.36-5.18-2.2-5.81-2.31-.63-.12-.74.39-.69.64.08.44 5 2.09 5.06 2.23.06.14-.44-.02-.44-.02s-5.36-1.27-5.81-.99c-.45.28-.1.71.1.85 0 0-.61.45-.1.81.52.36 1.25.67 1.25.67s-.79.21-.39.64c.39.43 3.21 1.07 3.21 1.07s5.49-1.2 6.63-1.07Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M509.85 98.16c-.48-.59-1.21-.55-1.72-.43-.44-.3-.99-.64-.99-.64-2.26-1.31-6.31-.67-7.8-.03-2.2 1.8-2.37 4.86-2.26 6.55.04.4.09.8.14 1.19v.01c.2 1.68.4 3.14.4 3.14l.7.81s-.18-2.8.25-2.95c.23-.08.29-.65.29-1.15 0-.43-.04-.82-.04-.82 4.48-2.06 9.51-.59 9.62-.31.07.18.17.72.27 1.19.06.29.12.55.17.7.13.4.08 2.92.08 2.92l.87-1.14s.19-.96.4-2.24c0 0 .04-.2.07-.53.35-2.42.15-5.55-.45-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M28.39 22.18s-1.23 1.61-3.84 3.33l1.62 2.5 2.77-4.96-.55-.87Z",
    transform: "translate(479 96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M20.62 22.55s1.56 1.96 3.93 2.95l-1.79 2.58-3.14-4.41 1-1.12Z",
    transform: "translate(479 96)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M645.44 288.56c-1.03.94-1.22 2.43-2.35 3.09-.33.19-.97.39-1.73.52-1.38.25-3.14.3-3.99-.2-.29-.17-.48-.4-.52-.72-.2-1.73 2.37-3.67 3.5-4.54.7-.53 1.42-1.77 1.99-2.91.36-.71.66-1.38.86-1.82.01.01.07.12.23.24.23.17.67.33 1.45.21 1.08-.18 1.5-.46 1.63-.57l.02-.02.02-.02.01-.01c.22 1.08.58 2.19.71 2.71.45 1.82-.86 3.15-1.83 4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M628.53 211.44s-3.64 12.7-4.28 15.94c-.64 3.24-2.42 18.94-2.61 21.61-.19 2.67-2.88 15.18-3.01 16.13-1.01 7.07-2.19 16.87-2.19 16.87s2.3 2.72 3.39-.08c3.82-9.82 5.76-11.63 6.6-18.14 1.65-12.84 3.33-12.73 3.9-14.23 5.7-15.16 6.65-23.8 7.42-24.69.76-.89.87.45 1.31 2.42.44 1.97-.18 15.53.62 20.76.44 2.85 1.42 9.24 1.74 12.92.32 3.69 1.98 20.74 1.98 20.74s2.06 2.84 3.14.14c.1-.25 2.06-15.99 2.13-20.38.06-4.38-1.87-5.01-.32-13.5 3.33-18.2 2.87-21.33-1.02-34.41-9.52-31.98-18.8-2.1-18.8-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M52.42 59.36s5.78 11.98 1.9 36.27c0 0-11.79-1.1-29.48-2.37 0 0 8.05-32.69 8.27-34.76.22-2.08 19.31.86 19.31.86Z",
    transform: "translate(595 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F3A5E",
    d: "M643.4 281.7s-1.27 1.78-1.13 2.05c.13.27 2.76.69 3.21.06.45-.63 1.07-1.98 1.07-1.98s-2.44 1.2-3.15-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M618.52 288.25c-1.33.4-1.73 2.66-2.86 3.33-1.13.67-6.66 1.13-6.86-.6-.2-1.73 2.32-3.28 3.45-4.15 1.13-.86 3.67-3.71 4.19-4.84 0 0 .46.72 1.81.5 1.35-.22 1.58-.58 1.58-.58-.05 1.34.42 2.29.55 2.81.47 1.8-.53 3.13-1.86 3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M606.8 188.87s-1.29-1.18-.99-2.13c.25-.81-.01-2.03-.09-2.41-.11-.51.15-2.18-.49-2.05-.64.13-.55 2.73-.64 3.29-.09.55-1.72-1.34-2.29-1.45-.57-.11-3.55 2.77-2.28 3.93 1.27 1.17 3.4 1.58 3.58 1.83.18.25.89.89.89.89l2.31-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M602.66 184.32s-4.12-3.32-4.58-3.31c-.46.01-.63.24-.25.57.37.33 3.89 3.32 3.89 3.32s-5.54-3.1-5.92-3.18c-.22-.04-.57.39-.39.58.18.19 5.5 3.58 5.5 3.58s-5.18-2.89-5.51-2.86c-.29.03-.51.51-.14.75s5.02 3.19 5.02 3.19-3.9-1.87-4.17-1.67c-.16.12-.48.48.54.93 1.02.45 3.32 1.77 3.32 1.77l2.69-3.67ZM669.73 173.14s1.29-1.18.99-2.13c-.25-.81.01-2.03.09-2.41.11-.51-.15-2.18.49-2.05.64.13.55 2.73.64 3.29.09.55 1.72-1.34 2.29-1.45.57-.11 3.54 2.77 2.28 3.93-1.27 1.17-3.4 1.58-3.58 1.83-.18.25-.89.89-.89.89l-2.31-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M673.87 168.59s4.12-3.32 4.58-3.31c.46.01.63.24.25.57-.37.33-3.89 3.32-3.89 3.32s5.54-3.1 5.92-3.18c.22-.04.57.39.39.58-.18.19-5.5 3.58-5.5 3.58s5.18-2.89 5.51-2.86c.29.03.51.51.14.75s-5.02 3.19-5.02 3.19 3.9-1.87 4.17-1.67c.16.12.48.48-.54.93-1.02.45-3.32 1.77-3.32 1.77l-2.69-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M635.67 151.91s4.32-.45 5.88 3.72c1.56 4.18 3.02 5.54 3.21 7.74.74 8.87 4.89 6.87 3.72 11.98-1.16 5.11-1.97 5.89-1.97 5.89l-9.91-1.94-10.03.03s3.93-1.96 3.05-6.14c-.87-4.18-3.05-11.02-1.82-15.68 1.23-4.67 5.29-5.25 7.87-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M77.98 24.13c-.15-.16-9.4 6.06-10.41 6.64-1.98 1.15-4.14 1.09-6.38 1.22-2.52.15-5.37-.11-7.84.38-1.28.26-1.43.59-2.1 1.95-1.81 3.7-2.4 8.31-2.64 12.38-.25 4.25 1.38 7.2 3.09 10.95.58 1.27 1.32 2.35.7 3.41-.73 1.26-3.43 1.6-4.76 1.77-3.27.43-8.1.05-11.44-.61-5.6-1.11-3.17-6.45-3.58-9.84-.28-2.27-1.37-5.67-2-7.87-.62-2.17-.69-3.08-.57-5.39-1.2 3.42-1.97 8.65-5.21 10.82-2.51 1.68-4.99.03-6.79-1.54-3.42-2.97-6.83-5.95-10.25-8.92.73-.67 1.46-1.34 2.18-2.02.24-.22.25-.28.53-.5.64-.51.56-.7 1.22-.25.44.3 1.62 1.4 2 1.75 1.24 1.15 2.32 1.85 3.56 3 1.08 1 3.97 2.59 4.38 2.23 1.08-.92 1.81-2.93 2.25-4.08 1.21-3.2 2.44-6.43 3.88-9.54 1.55-3.33 4.97-5.09 8.29-6.42 2.88-1.15 6.73-.92 9.64-.18 2.05.52 2.78.55 4.81 1.12 1.95.54 3.77 1.23 5.74 1.64 2.3.48 4.65.64 7 .67 1.85.02 2.61-.29 4.16-1.37 2.09-1.45 5.86-4.63 8.12-5.87.54-.26 2.04 2.88 2.42 4.47Z",
    transform: "translate(595 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M43.77 22.75c-.33-1.77-.11-4.5-.11-4.5s-6.03-1.27-5.77.86c.17 1.41-.16 3.05-.4 4-.64.22-1.02.41-1.02.41-.99 4.82 2.68 8.07 2.68 8.07 3.71-1.4 6.58-8.09 6.58-8.09-.66-.35-1.32-.58-1.96-.75Z",
    transform: "translate(595 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M41.24 3.35s5.73.83 4.89 9.28c-.84 8.45-5.89 7.78-6.23 7.78-.34-.01-5.07.18-5.48-10.14 0-.01-.19-7.64 6.82-6.92Z",
    transform: "translate(595 151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131C24",
    d: "M635.59 157.41s2.68 2.81 3.92 4.24c1.24 1.43 1.39 4.18 1.39 4.18s2.09-2.56 1.22-5.54c-.88-2.98-2.95-8.77-8.19-6.99-5.24 1.78-5.44 9.61-4.82 13.5-.02-.01 2.34-8.58 6.48-9.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1289CC",
    d: "M273.64 268.22h8.53v168.17h-8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M269.45 268.22h8.53v168.17h-8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1289CC",
    d: "M301.17 268.22h8.49v168.17h-8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M296.98 268.22h8.49v168.17h-8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125CAE",
    d: "M93.01 268.22h8.53v168.17h-8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M88.83 268.22h8.53v168.17h-8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1289CC",
    d: "M120.55 268.22h8.5v168.17h-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M116.36 268.22h8.49v168.17h-8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M57.62 261.24h268.52v16.66H57.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "m177.53 95.3 82.63-5.82 1.32 2.9-10.84 59.12h-3.8l-81.69 5.02z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M174.63 195.48h85.24l-12.38 61.26h-85.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M224.36 150.63h23.39v4.61h-23.39z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#431CA3",
    d: "M145.56 256.63h78.79v4.61h-78.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F2759",
    d: "m177.53 199.03-10.95 54.12h77.99l10.94-54.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M191.88 261.24c2.64.33 8.2-.51 12.16-3.08 3.92-2.56 7.03-5 7.03-5s8.54 1.11 9.09-.84c.24-2.61-11.06-5.69-12.64-5.88-1.61-.18-14.87 1.68-16.22 3.04-1.36 1.36.58 11.76.58 11.76ZM147.72 253.81c2.64.33 8.2-.51 12.12-3.08 3.92-2.56 7.65-6.3 7.65-6.3s8.53.81 8.35 0c-.22-.77-10.91-5.24-12.52-5.42-1.57-.18-14.86 1.69-16.22 3.04-1.36 1.36.62 11.76.62 11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M163.21 243.48c.84 1.06 6.19 5.05 5.16 6.59-1.03 1.58-3.48 2.23-6.15.29-2.67-1.94-4.36-4.21-3.62-4.98.73-.76 4.61-1.9 4.61-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M49.38 84.72c-8.13 3.3-6.19 18.97-2.49 30.21 3.66 11.24 41.63 37.78 52.87 40.71 11.24 2.89 54.85-10.73 54.85-10.73 2.97-6.04.4-12.45-4.98-11.06 0 0-42.51 6.66-48.88-.7-5.13-5.88-42.77-51.91-51.37-48.43Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M83.79 64.36C70.5 91.12 43.19 82.19 36.74 56.6 30.3 31.04 28.61 8.97 51.02 5.09 75.37.88 97.12 37.6 83.79 64.36Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.2 170.95c2.53 7.95 1.76 29.25 1.76 29.25s35.95 10.47 34.86 5.64c-4.39-19.59-6.63-36.72-10.65-40.31-3.34-2.93-11.54 6.92-25.97 5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M115.47 412.16s7.72 9.34 17.72 13.51 14.5 5.97 12.89 8.53c-1.61 2.56-14.43 1.35-24.09 1.68-9.63.33-16.15 1.06-16.48-2.01-.33-3.04 1.21-19.92 1.21-19.92l8.75-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M101.41 233.52c.37 10.47 3.92 88.99 3.92 88.99 2.48 2.87 18.9-3.02 20.05-7 0 0 7.04-87.41 4.3-87.81-2.72-.37-28.27 5.82-28.27 5.82Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M199.82 412.53s7.72 9.34 17.68 13.55c10 4.18 14.5 5.93 12.89 8.53-1.61 2.56-14.43 1.32-24.06 1.65-9.67.33-16.18 1.06-16.51-1.98-.33-3.07 1.21-19.95 1.21-19.95l8.79-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M48.13 201.92c-1.17 8.16-13.58 20.94 1.54 33.72 15.12 12.78 112.48 1.98 113.72 3.7 1.24 1.69 25.34 84.53 25.34 84.53s20.85-.66 19.75-9.19c-8.05-22.22-6.72-93.17-23.01-100.93-16.25-7.76-137.34-11.83-137.34-11.83Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M88.04 86.85c-13.95-3.7-55.63-6.68-61.22 5.24-12.97 27.68-2.65 134.05 15.41 135.8 11.61 1.14 69.21-.63 71.15-21.53 2.52-27.5-22.92-67.27-25.34-119.51Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.71 279.64h14.13v70.15H25.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M22.7 279.08h14.13v70.15H22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M88.04 86.85c-8.13 3.3-6.22 19-2.53 30.24 3.7 11.2 41.67 37.75 52.91 40.68 11.24 2.89 56.2-2.78 56.2-2.78 2.93-6.04.4-12.45-5.02-11.06 0 0-43.86-1.28-50.23-8.64-5.08-5.9-42.76-51.92-51.33-48.44Z",
    transform: "translate(0 106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M73.91 136.61c-2.6-3.29 4.5 10.47 2.34 16.26.04-6.19-14.97-13.66-9.19 3.15.7 2.05 1.57 10.81 1.57 10.81-.15 3.61-18.61 14.52-24.71 10.31-5.53-3.22-14.28-16.18-19.88-30.72-5.64-14.54 4.25-21.64 4.25-21.64s-1.35-3.7 3.11-10.65c3.48-5.49 55.32-16.37 52.54 7.58-.58 4.94-5.78 9.22-10.03 14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.96 222.47h53.78c3.89 0 7.1 4.32 7.1 9.59v40.13c0 5.27-3.21 9.59-7.1 9.59H12.96c-3.92 0-7.13-4.32-7.13-9.59v-40.13c0-5.27 3.21-9.59 7.13-9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M7.67 222.59h53.78c3.89 0 7.1 4.32 7.1 9.59v40.13c0 5.27-3.21 9.59-7.1 9.59H7.67c-3.92 0-7.13-4.32-7.13-9.59v-40.13c.01-5.27 3.22-9.59 7.13-9.59ZM73.85 352.85h12.67v71.51H73.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M35.01 422.81h92.01v5.02H35.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M125.08 435.81c3.73 0 6.74-3 6.74-6.7 0-3.74-3-6.74-6.74-6.74-3.7 0-6.7 3-6.7 6.74 0 3.7 3 6.7 6.7 6.7ZM79.37 435.66c3.73 0 6.74-3 6.74-6.7 0-3.73-3-6.74-6.74-6.74-3.7 0-6.7 3-6.7 6.74 0 3.7 3 6.7 6.7 6.7ZM35.3 435.81c3.7 0 6.74-3 6.74-6.7 0-3.74-3.04-6.74-6.74-6.74s-6.74 3-6.74 6.74c0 3.7 3.04 6.7 6.74 6.7ZM20.78 341.64h118.78c4.5 0 8.16 3.66 8.16 8.13 0 4.51-3.66 8.16-8.16 8.16H20.78c-4.47 0-8.13-3.66-8.13-8.16.01-4.46 3.67-8.13 8.13-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCD8FA",
    d: "M41.04 190.78c.18-2.34 1.84-8.94 1.84-8.94s26.95-1.83 33.35 1.17c1.01.47 7.23 9.65 7.23 9.65-16.99-3.08-31.52-3.22-42.42-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E8191",
    d: "M177.53 199.03h77.98l-.49 2.43-78.01.15zM244.17 207.46c0 .37-.3.66-.66.66h-61.66a.66.66 0 1 1 0-1.32h61.66c.36 0 .66.3.66.66ZM232.06 211.23c0 .37-.24.66-.54.66h-50.55c-.3 0-.54-.3-.54-.66 0-.37.24-.66.54-.66h50.55c.29 0 .54.3.54.66ZM231.3 215.88c0 .37-.24.66-.54.66h-50.55c-.3 0-.54-.3-.54-.66 0-.37.24-.66.54-.66h50.55c.3 0 .54.3.54.66ZM241.65 219.96c0 .37-.3.66-.66.66h-61.73a.66.66 0 1 1 0-1.32h61.73c.37 0 .66.3.66.66ZM239.37 229.66c0 .37-.3.66-.66.66h-61.73a.66.66 0 1 1 0-1.32h61.73c.36 0 .66.3.66.66ZM217.02 224.56c0 .37-.19.66-.41.66h-38.43c-.23 0-.41-.3-.41-.66 0-.37.18-.66.41-.66h38.43c.23 0 .41.3.41.66ZM204.18 233.89c0 .37-.13.66-.3.66h-27.74c-.16 0-.3-.3-.3-.66 0-.37.13-.66.3-.66h27.74c.17 0 .3.3.3.66ZM225.35 239c0 .37-.24.66-.53.66h-49.66c-.29 0-.53-.3-.53-.66 0-.37.24-.66.53-.66h49.66c.3 0 .53.3.53.66Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForSignUp);
export default __webpack_public_path__ + "static/media/forSignUp.eab05c19796f9c457e49f7626eaba648.svg";
export { ForwardRef as ReactComponent };